module.exports = __webpack_public_path__ + "static/media/soumya.f01fcd79.jpg";